export default "__VITE_ASSET__CyF9CyMZ__"